module.exports = __webpack_public_path__ + "static/media/notavailableC.8bbcdf05.svg";